<template>
  <div class="header">
    <!--    <div class="system fixedHead" :class="{$store.state.headerBg ? 'activeClass' : ''}" id="barHeight">-->
    <!-- :style="{
        top: refresh ? '-20px' : '0',
      }" -->
    <div class="system fixedHead" :class="{ activeClass: $store.state.headerBg, addPadding: fixedModule }"
      id="barHeight">
      <div class="systemItem" id="setHeight">
        <template v-if="!this.$route.meta.notReturnBtn">
          <img class="leftImg" @click="onClickLeft" v-show="$store.state.headerBg"
            src="@assets/images/fundDetail/goBack.png" />
          <img class="leftImg" @click="onClickLeft" v-show="
            !$store.state.headerBg &&
            $route.path != '/personalProcess/uploadMaterial' &&
            $route.path != '/personalConfirmation' &&
            $route.path != '/orgConfirmation'
          " src="@assets/images/header/backIcon.png" />
        </template>
        <template v-if="
          urlReturn === this.$route.path || this.$route.path == '/riskResult1'
        ">
          <img class="leftImg" @click="returnNativeFun" src="@assets/images/header/backIcon.png" />
        </template>
        <template v-else-if="showCurrent">
          <img class="leftImg" @click="returnNativeFun" src="@assets/images/header/backIcon.png" />
        </template>
        <template v-else-if="returnH === '1'">
          <img class="leftImg" @click="returnDetail(-1)" src="@assets/images/header/backIcon.png" />
        </template>
        <template v-if="$route.meta.singleName">
          <div class="defaultS van-multi-ellipsis--l2">
            {{ customFundName }}
          </div>
        </template>
        <template v-else-if="$route.meta.repeatName">
          <div class="defaultS van-multi-ellipsis--l2">
            {{ repeatNameInfo }}
          </div>
        </template>
        <template v-else>
          <div class="publicfunds-detail-box" v-if="
            (!isDetail && $route.path == '/publicFundsDetail') ||
            (!isDetail &&
              $route.path != '/publicFundsDetail' &&
              $route.path != '/newFundDetail') ||
            ($route.path == '/newFundDetail' && !scrollFlag)
          ">
            <div v-if="
              (!isDetail && $route.path == '/publicFundsDetail') ||
              (!isDetail &&
                $route.path != '/publicFundsDetail' &&
                $route.path != '/newFundDetail') ||
              ($route.path == '/newFundDetail' && !scrollFlag)
            ">
              {{ title }}
              <!-- 临时，为了生产 -->
              <div
                class="share-news"
                @click="
                  newShareEvent($route.path == '/newFundDetail' ? true : false)
                "
                v-if="
                  $route.path == '/publicFundsDetail' ||
                  $route.path == '/newFundDetail'
                "
              >
                <img
                  src="@/assets/images/publicFundsChange/share_white.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 新品首发 -->
          <div v-else-if="$route.path == '/newFundDetail' && scrollFlag" class="">
            <div>
              <span :style="{
                fontSize: changeCharSize ? '14px' : 'inherit',
              }">{{ newFoundItem.fundName }}</span>
              <span class="stock-code">{{ newFoundItem.fundCode }}</span>
            </div>
            <!-- 临时，为了生产 -->
            <div class="share-news-scroll" @click="newShareEvent(true)">
              <img
                src="@/assets/images/publicFundsChange/share_white.png"
                alt=""
              />
            </div>
          </div>
          <!-- 公募详情 -->
          <div v-else-if="isDetail" class="">
            <div>
              <span :style="{
                fontSize: changeCharSize ? '14px' : 'inherit',
              }">{{ finfoName }}</span>
              <span class="stock-code">{{ foundCode }}</span>
            </div>
            <!-- 临时，为了生产 -->
            <div
              class="share-news-scroll"
              @click="newShareEvent(false)"
              v-if="isDetail"
            >
              <img
                src="@/assets/images/publicFundsChange/share_white.png"
                alt=""
              />
            </div>
          </div>
        </template>
        <!-- <img v-show="$store.state.headerBg" class="rightImg" src="@assets/images/fundDetail/share.png" /> -->
      </div>
      <div class="screenIng" @click="showScreenIng = true" v-if="$route.meta.showScreening">
        <span class="wordDes">筛选</span>
        <van-icon name="arrow-down" class="screenIcon" />
      </div>
      <div class="rightOpera">
        <div class="skipStep" v-if="this.$route.meta.skipStep">
          <van-icon name="question-o" v-if="this.$route.meta.uploadIcon" class="quesMore" @click="searchUploadPage" />
          <a @click="callPhoneEvent" class="phoneIcon" v-if="this.$route.meta.phone"></a>
          <!-- @click="skipFunction" -->
          <div v-if="this.$route.meta.skipStep.stepName !== ''" class="distanceStyle" @click="skipFunction">
            <span class="wordDes">跳过</span>
            <van-icon name="arrow" class="screenIcon" />
          </div>
        </div>
        <div class="skipStep searchDetail" v-if="hideDetail" @click="searchPrivateDetail">
          <div>详情</div>
        </div>
        <div class="skipStep searchDetail" v-if="this.$route.meta.showDetail" @click="searchPubDetail">
          <div>详情</div>
        </div>
      </div>
      <div class="rightOpera">
        <div class="question" v-if="this.$route.meta.questionIcon" @click="goQuestion">
          <span class="questionIcon">
            <img src="../assets/images/evaluation/questionIcon.png" alt="" />
          </span>
        </div>
      </div>
      <div class="rightOpera">
        <div class="sendStyle" v-if="this.$route.meta.sendEmail && fileList === '1'" @click="showSureEmail = true">
          <span>发送到邮箱</span>
        </div>
      </div>
      <div class="rightOpera phone">
        <div class="callPhone" v-if="this.$route.meta.showPhoneIcon" @click="handlePhone(customerServicePhone)">
          <span class="callPhoneIcon">
            <img src="../assets/images/header/phone.png" alt="" />
          </span>
        </div>
      </div>
      <div class="commonRight">
        <div class="iconItem" @click="searchQuestion" v-if="this.$route.meta.questionName">
          <van-icon name="question-o" />
        </div>
      </div>
      <div class="rightOpera">
        <div class="sendStyle alignClass" v-if="this.$route.meta.oldValidate" @click="turnExample">
          <span>查看示例</span>
        </div>
      </div>
    </div>
    <van-popup v-model="showScreenIng" position="top" class="costomPopover" :style="{ top: dynamicTop }">
      <div class="tradingTime">
        <div class="tradingTime__top">
          <div class="tradingTitle">交易时间</div>
          <div class="tradingList">
            <div class="tradingItem" :class="{ isClicked: item.flag }" v-for="(item, index) in timeArea" :key="index"
              @click="chooseItem(item, index)">
              {{ item.time }}
            </div>
            <div class="tradingItem" :class="{ isClicked: startTimeClicked }" @click="clickStartTime('start')">
              {{ startTime ? startTime : "起始时间" }}
            </div>
            <div class="tradingItem" :class="{ isClicked: endTimeClicked }" @click="clickStartTime('end')">
              {{ endTime ? endTime : "结束时间" }}
            </div>
          </div>
        </div>
        <div class="operaBtn">
          <div class="btnNormal defaultBtn" @click="resetState">重置</div>
          <div class="btnNormal primaryBtn" @click="confirmBtn">确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showStartTimePicker" position="bottom">
      <van-datetime-picker v-model="currentDate" type="date" :title="timeTitle" :min-date="minDate" :max-date="maxDate"
        @confirm="getStartTime" />
    </van-popup>
    <van-dialog v-model="showDialog" showConfirmButton class="wrapperMod" @confirm="showDialog = false">
      <div class="wrapper1">
        <div class="top">
          本人确认上述信息真实、准确和完整，且当这些信息发生变更时将在30日内通知贵机构
        </div>
        <div class="center">
          中国税收居民：是指在中国境内有住所，或者无住所而一个纳税年度内在中国境内居住累计满183天的个人。在中国境内有住所是指因户籍、家庭、经济利益关系而在中国境内习惯性居住。所谓习惯性居住，是判定纳税人义务人是居民或非居民的一个法律意义上的标准，不是指实际居住或在某一个特定时期内的居住地。
        </div>
        <div class="bottom">
          非居民：是指中国税收居民以外的个人。其他国家（地区）税收居民身份认定规则及纳税人识别号相关信息请参见国家税务总局网站。（http://www.chinatax.gov.cn/aeoi_index.html）。
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showSureEmail" class="commonTip" :show-confirm-button="booleanVal"
      :show-cancel-button="booleanVal">
      <div class="title">请确认您的邮箱地址</div>
      <div class="center">
        <van-field v-model="customEmial" class="customInput" :formatter="formatteEntip" />
        <div v-text="dynamicTips" class="errorTip"></div>
      </div>
      <div class="footer">
        <div class="commonS cancelBtn" @click="cancelFun">取消</div>
        <div class="commonS confirmBtn" @click="sendEmailFun">确认并发送</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import bus from "@config/bus";
import { mapState } from "vuex";
import { NATIVE_BACK, MY_PATH, ADD_RECORD_Path } from "../common/index";
import comment from "../common/commonMethods";
import commonRegular from "../common/regular";
export default {
  name: "HelloWorld",
  props: {
    isDetail: {
      type: Boolean,
      default: false,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
    finfoName: {
      // type: Number,
    },
    foundCode: {
      default: "获取中...",
    },
    remark: {
      default: "",
    },
  },
  data() {
    (this.minDate = new Date(1900, 1, 1)),
      (this.maxDate = new Date(2099, 1, 1));
    return {
      kfPhone: "400-168-1235",
      title: "",
      fixedModule: false,
      showScreenIng: false,
      timeArea: [
        {
          flag: true,
          time: "不限",
        },
        {
          flag: false,
          time: "近一周",
        },
        {
          flag: false,
          time: "近一月",
        },
        {
          flag: false,
          time: "近三月",
        },
      ],
      flag: "",
      showReturnIcon: "",
      urlReturn: "",
      returnH: "",
      showStartTimePicker: false,
      showEndTimePicker: false,
      currentDate: new Date(2021, 7, 17),
      startTime: "",
      endTime: "",
      transactionStartTime: "", //接口所需
      transactionEndTime: "", //接口所需
      startTimeClicked: false,
      endTimeClicked: false,
      dynamicTop: "",
      timeTitle: "",
      timeFlag: "",
      hideDetail: false,
      showCurrent: false,
      //
      beforeUrl: "",
      changeCharSize: false,
      scrollFlag: false,
      showDialog: false,
      customFundName: "",
      fileList: "",
      showSureEmail: false,
      booleanVal: false,
      dynamicTips: "",
      customEmial: "",
      repeatNameInfo: "私募证券",
      aboutDocObj: {}
    };
  },
  computed: {
    ...mapState([
      "statusHeight",
      "clickType",
      "routePathList",
      "returnBtn",
      "getOpenAccount",
      "customerServicePhone",
      "personalAccount",
      "returnFlag",
      "survivalType",
      "riskTitle",
      "curFundCode",
      "formInfoObj",
      "personInfoId",
      "uploadList",
      "notFromNative",
      "fromTransPage",
      "investorFlag",
      "centerFlag",
      //新增
      "customName", //1
      "accountCompany", //2
      "accountSource", //3
      "pageInfo", //4
      "thirdProvinceInfo", //5
      "isRiskFlag", //用户是否风测
      "routeStr",
      "privateRf",
      "publicRf",
      "fromAccountInfo",
      "newFoundItem",
      "scrollHeaderFlag_new",
      "parentIdInfo",
      "detailFlag",
      "repeatRisk",
      "accountIn",
      "skipList",
      "shareDetail", //公募详情分享
      "batchOrderInfo"
    ]),
  },
  watch: {
    newFoundItem: {
      handler(v) {
        if (v.fundName && v.fundName.length >= 19) {
          this.changeCharSize = true;
        } else {
          this.changeCharSize = false;
        }
      },
    },
    scrollHeaderFlag_new(v) {
      this.scrollFlag = v;
    },
    $route(to) {
      let that = this;
      if (
        (to.query.moduleSearch &&
          (to.query.moduleSearch === "1" || to.query.moduleSearch === "3")) ||
        (to.query.moduleSearch && to.query.moduleSearch === "6") ||
        (to.query.moduleSearch && to.query.moduleSearch === "7")
      ) {
        that.title = "银行列表";
      } else {
        that.title = to.name;
      }
      that.showPublicHeader = false;
      // if (to.path === "/investmentRe") {
      //   this.watchDataVal(this.personalAccount);
      // }
      if (to.query.comeFromAccount) {
        this.showCurrent = true;
        return;
      }
      this.showCurrent = false;
    },
    personalAccount: {
      handler(newV) {
        if (newV.entryInvestmentPage) {
          this.$store.commit("changeSurvivalType", newV.fundType); // 存续类型//1公募，2私募
          this.getInvestList();
        }
        if (newV.privateType) {
          if (newV.privateType === "1") {
            this.repeatNameInfo = "私募证券";
          } else if (newV.privateType === "5") {
            this.repeatNameInfo = "私募股权";
          } else if (newV.privateType === "4") {
            this.repeatNameInfo = "其他产品";
          }
        }
      },
      immediate: true,
    },
    statusHeight: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            let heig = Number(this.statusHeight.statusBar_height);
            let data = heig / 100 + "rem";
            let $dom = document.getElementById("setHeight");
            $dom.style.paddingTop = data;
            this.dynamicTop = (heig + 48) / 100 + "rem";
          });
        }
      },
      deep: true,
      immediate: true,
      strLen: 0,
    },
    "getOpenAccount.returnH": {
      handler(newV) {
        if (newV) {
          this.returnH = this.getOpenAccount.returnH;
        }
      },
      immediate: true,
    },
    finfoName(v) {
      //超出变小
      if (v && v.length >= 19) {
        this.changeCharSize = true;
      } else {
        this.changeCharSize = false;
      }
    },
    parentIdInfo: {
      handler(newV) {
        this.customEmial = newV.email;
      },
      immediate: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.beforeUrl = from.path;
    });
  },
  methods: {
    newShareEvent(isNewFund) {
      var url;
      var shareName;
      if (isNewFund) {
        // url = `http://192.168.186.215:8082/newFundShareDetail?productId=${this.shareDetail.productId}&isNewFundDetail=1&riskLevelValue=${this.shareDetail.riskLevelValue}&riskLevel=${this.shareDetail.riskLevel}`
        url = `${process.env.VUE_APP_API_URL}:8001/newFundShareDetail?productId=${this.shareDetail.productId}&isNewFundDetail=1&riskLevelValue=${this.shareDetail.riskLevelValue}&riskLevel=${this.shareDetail.riskLevel}`;
        shareName = this.newFoundItem.fundName;
      } else {
        // url = `http://192.168.186.215:8082/publicFundsShareDetail?productId=${this.shareDetail.productId}&isNewFundDetail=0&typeOfPurchase=${this.shareDetail.typeOfPurchase}`
        url = `${process.env.VUE_APP_API_URL}:8001/publicFundsShareDetail?productId=${this.shareDetail.productId}&isNewFundDetail=0&typeOfPurchase=${this.shareDetail.typeOfPurchase}`;
        shareName = this.finfoName;
      }
      const params = {
        requestType: "share-h5-webview-page",
        requestData: {
          shareType: "URL",
          //
          // shareTargets: [101, 102, 103, 104, 105, 198, 199],
          shareTargets: [101, 102, 105, 199,198],
          // shareUrl: `${process.env.VUE_APP_API_URL}:8001/downloadAppPage?productId=${this.shareDetail.productId}&isNewFundDetail=0&riskLevelValue=${this.shareDetail.riskLevelValue}&riskLevel=${this.shareDetail.riskLevel}`,
          // shareUrl: `http://192.168.186.88:8081/downloadAppPage?productId=${this.shareDetail.productId}&isNewFundDetail=0&riskLevelValue=${this.shareDetail.riskLevelValue}&riskLevel=${this.shareDetail.riskLevel}`,
          shareUrl: url,
          shareTitle: shareName,
          shareDesc: this.remark ? this.remark : "",
          shareId: this.shareDetail.productId,
          shareCutImage: "2", //
          otherData: {
            shareId: this.shareDetail.productId, //产品id
            shareType: "1",
          },
        },
      };
      // dsBridge.call('requestEventData', params, (res) => {
      //   console.log(res);
      // });
      // return
      if(this.$store.state.getHeadInfo.company==1){
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.requestEventData.postMessage(params);
        } else {
          window.android.requestEventData(JSON.stringify(params));
        }
      }
    },
   
    callPhoneEvent() {
      //拨打客服电话
      this.$dialog
        .confirm({
          title: "服务热线",
          message: this.kfPhone,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        })
        .then(() => {
          if (this.IOS.ios()) {
            window.location.href = "tel://" + this.kfPhone;
          } else {
            window.android.returnBackPhoneNumber(this.kfPhone);
          }
        });
    },
    watchDataVal(val) {
      if (val.company || val.companyId) {
        this.getInvestList();
        return;
      }
      this.watchDataVal(val);
    },
    searchPrivateDetail() {
      bus.$emit("startPopup");
      // this.$store.commit("changeNotFromNative", true);
      // let num = 3;
      // this.$store.commit("changeDefaultPriNum", num);
      // this.$router.push({
      //   path: "/primaryMarketDetail",
      //   query: {
      //     reloadPage: "1",
      //   },
      // });
    },
    searchPubDetail() {
      // 去公募详情前判断是否有前置页 有去前置页 没有直接详情
      if (this.$store.state.getOpenAccount.showFrontPage) {
        comment.gotoFrontPage(
          this,this.$store.state.getOpenAccount.frontPageUrl,
          this.$store.state.getOpenAccount.productId,
          this.$store.state.getOpenAccount.riskLevelValue,
          this.$store.state.getOpenAccount.riskLevel,
          this.$store.state.getOpenAccount.typeOfPurchase
        )      
      } else {
        this.$store.commit("changeNotFromNative", true);
        this.$router.push({
          path: "/publicFundsDetail",
          query: {
            reloadPage: "1",
          },
        });
      }
    },
    turnExample() {
      this.$router.push("/searchOldExample");
    },
    searchUploadPage() {
      if (
        this.$route.meta.uploadTitle &&
        this.$route.meta.uploadTitle == "identityFile"
      ) {
        this.showDialog = true;
        return;
      }
      if (
        this.$route.meta.uploadTitle &&
        this.$route.meta.uploadTitle == "identifiedUpload"
      ) {
        this.$router.push("/notIdentityExample");
        return;
      }
      this.$router.push("/searchExample");
    },
    searchQuestion() {
      let tag = this.$route.meta.questionName;
      if (tag === "identityDes") {
        this.showDialog = true;
        return;
      }
      if (tag === "myTaxInformation") {
        this.showDialog = true;
        return;
      }
      if (tag === "institutionTaxInformation") {
        this.showDialog = true;
        return;
      }
      if (tag === "uploadExample") {
        this.searchUploadPage();
      }
    },
    //获取接口投资检视数据
    getInvestList() {
      let _this = this;
      let params = {
        transactionStartTime: this.transactionStartTime,
        transactionEndTime: this.transactionEndTime,
        sysContractNo:
          this.parentIdInfo.sysContractNo ||
          this.personalAccount.sysContractNo ||
          "",
        companyId:
          this.personalAccount.company || this.personalAccount.companyId, //
        orgCommonId: this.personalAccount.orgCommonId, //集团客户机构表id
        fundCode: this.curFundCode || this.personalAccount.fundCode, //基金代码
        groupCommonId: this.personalAccount.groupCommonId,
      };
      let apiUrl =
        this.survivalType == "1"
          ? this.$api.investmentReviewPub
          : this.$api.investmentReview;
      this.$post(apiUrl, params).then((res) => {
        if (res.code === 10000) {
          _this.$store.dispatch("getInvest", res.data);
        }
      });
    },
    //item选择
    chooseItem(item, index) {
      this.startTimeClicked = false;
      this.endTimeClicked = false;
      this.startTime = "";
      this.endTime = "";
      this.timeArea.forEach((element) => {
        element.flag = false;
      });
      item.flag = !item.flag;
      this.getCurrentTime(index);
    },
    getCurrentTime(flag) {
      let curDate = this.curDateVal();
      switch (flag) {
        case 0:
          this.transactionStartTime = "";
          this.transactionEndTime = "";
          break;
        case 1:
          this.transactionStartTime = this.getDay(-7);
          break;
        case 2:
          this.transactionStartTime = this.getDay(-30);
          break;
        case 3:
          this.transactionStartTime = this.getDay(-90);
          break;
      }
      if ([1, 2, 3].includes(flag)) {
        this.transactionEndTime = curDate;
      }
    },
    // 当前年月日
    curDateVal() {
      let date = new Date();
      let y = date.getFullYear(); //获取完整的年份(4位)
      let m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //获取当前日(1-31)
      return y + "-" + m + "-" + d;
    },
    //点击开始时间
    clickStartTime(flag) {
      this.timeArea.forEach((element) => {
        element.flag = false;
      });
      this.timeFlag = flag;
      this.showStartTimePicker = true;
    },
    //选择开始时间
    getStartTime(time) {
      let date = new Date(time);
      let y = date.getFullYear();
      let m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let timer = `${y}-${m}-${d}`;
      if (this.timeFlag === "start") {
        this.startTime = timer;
        this.transactionStartTime = timer;
        this.startTimeClicked = true;
      }
      if (this.timeFlag === "end") {
        this.endTime = timer;
        this.transactionEndTime = timer;
        this.endTimeClicked = true;
      }
      this.showStartTimePicker = false;
    },
    //获取日期
    getDay(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    //日期处理
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    //重置
    resetState() {
      this.timeArea.forEach((element) => {
        element.flag = false;
      });
      this.startTimeClicked = false;
      this.endTimeClicked = false;
      this.startTime = "";
      this.endTime = "";
      this.transactionStartTime = ""; //接口所需
      this.transactionEndTime = ""; //接口所需
      (this.showScreenIng = false), this.getInvestList();
    },
    //确认
    confirmBtn() {
      // bus.$emit('changeScreening',this.flag);
      this.getInvestList();
      this.showScreenIng = false;
    },
    shoppingCartReturn(){
      let flag = false
      let routerL = localStorage.getItem('localRouter') || this.getOpenAccount?.localRouter || ''
      if(routerL && routerL == 'shoppingModule' && this.$route.path === '/accountInfo'){
        if(!(this.getOpenAccount?.batchOrderInfo?.routerSource) && this.IOS.ios()){
          window.webkit.messageHandlers.navToRootCartModule.postMessage("");
            flag = true
            return
        }
        this.$router.push({ path: "/shoppingCartModule" });
        localStorage.removeItem('localRouter')
        let obj = {
          ...this.getOpenAccount,
          localRouter:''
        }
        this.$store.dispatch("getOpenAccount", obj);
        flag = true
      }else if(routerL && routerL == 'shoppingModule' && this.$route.path === '/riskResult1'){
        this.$router.push("/accountInfo")
        flag = true
      }
      return flag
    },
    onClickLeft() {
      if(this.shoppingCartReturn()) return
      if (
        this.getOpenAccount?.isFromExternalLink === "1" &&
        this.$route.path === "/publicFundsDetail"
      ) {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.backToPubFundList.postMessage("");
        }
        return;
      }
      //相关文件返回,如果是原生跳转
      if (this.$route.path === "/aboutDoc" && this.aboutDocObj.isNative) {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }

      let isAddRecordsPath = ADD_RECORD_Path.includes(this.$route.path);
      if (isAddRecordsPath) {
        this.$router.go(-1);
        return;
      }
      if (
        this.getOpenAccount.advancedAgeSource &&
        this.getOpenAccount.advancedAgeSource === "1" &&
        this.$route.path === "/oldUploadMaterial"
      ) {
        this.$store.commit("changeUploadFile", []);
      }
      if (this.routeStr == "center" && this.$route.path === "/oldInvestors") {
        this.$store.commit("routerJump", "");
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }
      if (
        this.routeStr == "verify" &&
        this.$route.path === "/oldUploadMaterial"
      ) {
        this.$store.commit("routerJump", "");
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }
      if (this.$route.path === "/bankDetail") {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }
      if (this.$route.path === "/nativeHistoryPage") {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }
      if (this.$route.path === "/personalProcess/notIdentityInfo") {
        this.$router.go(-1);
        return;
      }
      if (this.$route.path === "/riskSeeResult") {
        this.$router.go(-1);
        return;
      }
      if (this.$route.path === "/accountProcess") {
        let data = {
          ...this.getOpenAccount,
        };
        data.accountType = "";
        this.$store.dispatch("getOpenAccount", data);
        this.$router.push({ path: "/personalProcess/realInfo" });
        return;
      }
      if (this.routeStr == "risk_to_riskQuestion") {
        this.$store.commit("routerJump", "");
        this.$router.go(-1);
        return;
      }
      if (
        this.routeStr == "survivalProduct" &&
        this.$route.path == "/productNotice"
      ) {
        this.$store.commit("routerJump", "");
        this.$router.go(-1);
        return;
      }
      if (
        this.routeStr == "historyInFlag" &&
        this.$route.path == "/secondSurvival"
      ) {
        this.$store.commit("routerJump", "");
        this.$router.go(-1);
        return;
      }
      if (
        this.$route.path === "/survivalDetail" &&
        this.personalAccount.isFromPubChoice == "1"
      ) {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }
      if (this.$route.path === "/historyNetValue") {
        this.returnDetail(-1);
        return;
      }
      if (this.$route.path === "/shareDetail") {
        this.$router.go(-1);
        return;
      }
      if (
        this.routeStr == "specialRiskRe" &&
        this.$route.path === "/riskQuestionPerson"
      ) {
        this.$store.commit("routerJump", "");
        this.$router.go(-1);
        return;
      }
      if (this.$route.path === "/riskQuestion") {
        this.$router.push({ path: "/orgRiskResult" });
        return;
      }
      if (
        this.$route.path === "/bankSearchList" &&
        this.$route.query.moduleSearch &&
        (this.$route.query.moduleSearch == "1" ||
          this.$route.query.moduleSearch == "2")
      ) {
        this.$router.push({ path: "/personalProcess/bindCard" });
        return;
      }
      if (
        this.$route.path === "/branchList" &&
        this.$route.query.type &&
        this.$route.query.type == "personBranch"
      ) {
        this.$router.push({ path: "/personalProcess/bindCard" });
        return;
      }
      if (
        this.$route.path === "/notIdentityExample" &&
        this.$route.query.flag &&
        this.$route.query.flag == "not"
      ) {
        let data = {
          ...this.getOpenAccount,
        };
        data.accountType = "notIdentity";
        this.$store.dispatch("getOpenAccount", data);
        this.$router.push({ path: "/personalProcess/typeIdentified" });
        return;
      }
      if (this.$route.path === "/orgRisk") {
        this.$dialog
          .confirm({
            message: "您尚未完成风险测评，是否放弃",
            confirmButtonText: "继续测评",
            cancelButtonText: "放弃测评",
          })
          .then(() => { })
          .catch(() => {
            this.riskReturnFun();
            return;
          });
        return;
      }
      this.riskReturnFun();
      if (
        this.routeStr == "investor_page" &&
        this.$route.path === "/investorIdentification1"
      ) {
        this.$store.commit("routerJump", "");
        this.$store.commit("changeInvestorFlag", "0");
        this.$router.push("/accountInfo");
        return;
      }
      if (
        this.routeStr == "invesement_private" &&
        this.$route.path === "/secondSurvival"
      ) {
        this.$store.commit("routerJump", "");
        this.$router.push("/privateSurvival");
        return;
      }
      if (
        this.routeStr == "investmentAnalysis" &&
        this.$route.path === "/secondSurvival"
      ) {
        this.$store.commit("routerJump", "");
        this.$router.push("/investmentAnalysis");
        return;
      }
      if (
        this.routeStr == "invesement_public" &&
        this.$route.path === "/survivalDetail"
      ) {
        this.$store.commit("routerJump", "");
        this.$router.push("/publicSurvival");
        return;
      }
      if (
        this.privateRf == "2" &&
        (this.$route.path === "/primaryMarketDetail" || this.$route.path === "/primaryOldDetail")
      ) {
        this.turnPage_primaryDetail();
        return;
      }
      if (this.publicRf == "2" && this.$route.path === "/publicFundsDetail") {
        this.turnPage_primaryDetail();
        return;
      }
      if (
        this.$route.path === "/bindCard1" &&
        this.getOpenAccount.privateFlag &&
        this.getOpenAccount.privateFlag === "1"
      ) {
        this.turnPrivate();
        return;
      }
      if (
        this.routeStr == "cx_detail" &&
        this.$route.path === "/publicFundsDetail"
      ) {
        this.returnDetail(-1);
        return;
      }
      if (this.$route.path === "/searchExample") {
        this.$router.go(-1);
        return;
      }
      if (this.$route.path === "/notIdentityExample") {
        let data = {
          ...this.getOpenAccount,
        };
        data.accountType = "notIdentity";
        this.$store.dispatch("getOpenAccount", data);
        this.$store.commit("changeNoIdentityUpload", this.materialList);
        this.$router.go(-1);
        return;
      }
      if (this.$route.path === "/searchExamplePer") {
        this.$router.push({
          path: "/investorIdentification1",
        });
        return;
      }
      if (this.$route.path === "/permissionsUploadMaterial") {
        this.$router.push({
          path: "/permissionsInvestorIdentification",
        });
        return;
      }
      if (this.$route.path === "/searchExampleVeri") {
        this.$router.push({
          path: "/permissionsInvestorIdentification",
        });
        return;
      }
      this.$store.commit("changeSelfVerify", []);
      if (this.$route.path === "/uploadMaterial1") {
        this.$router.push({
          path: "/investorIdentification1",
        });
        return;
      }
      if (this.$route.path === "/accountInfo") {
        this.turnRooter();
        return;
      }

      if (this.$route.path == "/contactMes") {
        this.$router.push("/accountInfo");
        return;
      }
      if (this.$route.path === "/permissionsInvestorIdentification") {
        this.turnPage();
        return;
      }
      if (this.$route.path === "/ocrCertificateInfo") {
        this.$router.push("/accountInfo");
        return;
      }
      if (this.clickType === "1") {
        if (
          this.$route.path === "/bindCard1" ||
          this.$route.path === "/riskAssessment1" ||
          this.$route.path === "/contactInfo" ||
          this.$route.path === "/assetCertificate" ||
          this.$route.path === "/permissionsInvestorIdentification"
        ) {
          this.returnNativeFun();
        } else {
          if (
            (this.detailFlag === "1" &&
              (this.$route.path === "/primaryMarketDetail"  || this.$route.path === "/primaryOldDetail")) ||
            (this.detailFlag === "1" && this.$route.path === "/investmentRe")
          ) {
            this.returnDetail(-1);
            this.$store.commit("changeDetailFlag", "0");
            return;
          }
          if (this.$route.path === "/orderDetail") {
            this.returnDetail(-1);
            return;
          }
          this.returnDetail(-1);
        }
      }
      //如果是历史投资返回
      if (this.$route.path === "/historyInvestment") {
        //如果是原生的跳转
        if (this.personalAccount && this.personalAccount.historyAsset) {
          if (this.IOS.ios()) {
            window.webkit.messageHandlers.authBack.postMessage("");
          } else {
            window.android.authBack();
          }
        } else {
          this.$router.go(-1);
        }
      }
      let routeResult = this.routePathList.includes(this.$route.path);
      if (
        this.$route.path == "/designatedAssets" &&
        this.fromAccountInfo === false
      ) {
        this.$router.push("/assetCertificate");
        return;
      }
      if (
        this.$route.path == "/assetCertificate" &&
        this.fromAccountInfo === false
      ) {
        if (this.accountIn === true) {
          this.$router.push("/accountInfo");
        } else {
          this.turnRooter();
        }
        return;
      }
      if (routeResult) {
        if (
          this.personalAccount.beiginPathIsPersonalBank &&
          this.$route.path == "/bankCardList"
        ) {
          this.turnRooter();
        } else {
          this.returnNativeFun();
        }
      } else {
        if (this.$route.path === "/riskAssessment1") {
          this.$dialog
            .confirm({
              message: "您尚未完成风险测评，是否放弃",
              confirmButtonText: "继续测评",
              cancelButtonText: "放弃测评",
            })
            .then(() => { })
            .catch(() => {
              if (this.repeatRisk === "1") {
                this.$router.push({ path: "/riskResult1" });
              } else {
                let returnObj = this.$store.state?.privateModule?.returnPageUrl
                if(returnObj){
                  this.$router.push({
                    path:returnObj,
                  })
                  return
                }
                if (this.IOS.ios()) {
                  this.turnPage_primaryDetail();
                } else {
                  window.android.closePrivateFundDetailsPage();
                }
              }
            });
        } else {
          if (this.$route.path == "/help" || this.$route.path == "/contactUs") {
            this.turnPage();
            return;
          }
          if (this.fromTransPage) {
            this.returnDetail(-1);
            this.$store.commit("changeBackStatus", false);
          } else {
            if (this.investorFlag === "1") {
              if (!this.IOS.ios()) {
                this.$store.commit("changeInvestorFlag", "0");
                this.$router.push("/accountInfo");
                return;
              }
              this.$store.commit("changeInvestorFlag", "0");
              this.$router.push("/accountInfo");
            } else {
              if (
                this.$route.path === "/bindCard" ||
                this.$route.path === "/bindNotIdCard"
              ) {
                this.$router.push("/bankCardList");
              } else if (this.$route.path === "/newFundDetail") {
                this.turnPage();
              } else {
                if (this.$route.path === "/investmentRe") {
                  //投资检视原生跳转返回
                  if (
                    this.personalAccount &&
                    this.personalAccount.investmentRe
                  ) {
                    if (this.IOS.ios()) {
                      window.webkit.messageHandlers.authBack.postMessage("");
                    } else {
                      window.android.authBack();
                    }
                  } else {
                    this.returnDetail(-1);
                  }
                } else {
                  this.returnDetail(-1);
                }
              }
            }
          }
        }
      }
      if (this.$route.path === "/survivalDetail") {
        if (!this.IOS.ios()) {
          this.$router.push("/publicSurvival");
          return;
        }
      }
    },
    turnPage() {
      if(this.shoppingCartReturn()) return
      if (this.routeStr == "account_to_risk") {
        //更多 - 个人信息 - 风测 - 个人信息
        this.$store.commit("routerJump", "");
        this.$router.go(-1);
      } else if (this.$route.path == "/assetCertificate") {
        if (this.accountIn === true) {
          this.$router.push("/accountInfo");
        } else {
          this.$router.go(-1);
        }
      } else {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
      }
    },
    turnPage_primaryDetail() {
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.authPrimaryList.postMessage("");
      } else {
        window.android.authPrimaryList();
      }
    },
    turnPrivate() {
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.navToPrivateDetailByBank.postMessage("");
      } else {
        window.android.authPrimaryList();
      }
    },
    returnDetail(num) {
      if(this.shoppingCartReturn()) return
      if (
        this.centerFlag === "1" &&
        this.$route.path === "/investorIdentification1"
      ) {
        this.turnRooter();
        return;
      }
      if (this.$route.path === "/accountInfo") {
        this.turnRooter();
        return;
      }
      this.showScreenIng = false;
      let obj = {
        ...this.getOpenAccount,
      };
      obj.returnH = "0";
      this.$store.dispatch("getOpenAccount", obj);
      this.$store.commit("changeInvestorFlag", "0");
      if (this.$route.path !== "/designatedAssets") {
        this.$router.go(num);
      }
    },
    //返回个人中心
    turnRooter() {
      if(this.shoppingCartReturn()) return
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.navToRoot.postMessage("");
      } else {
        window.android.navToRoot();
      }
    },
    riskReturnFun() {
      if(this.shoppingCartReturn()) return
      comment.getRiskSource(this.getOpenAccount.riskSource);
      if (this.routeStr == "personCenter_page") {
        this.turnCenter();
        return;
      }
      if (this.routeStr == "personCenterMore_page") {
        this.$store.commit("routerJump", "");
        this.$router.push({ path: "/orgAccountInfo" });
        return;
      }
      if (
        this.routeStr == "privateFund_page" ||
        this.routeStr == "publicFund_page"
      ) {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.riskResultToProductDetailByPermision.postMessage(
            ""
          );
        } else {
          window.android.authBack();
        }
        return;
      }
      if (this.routeStr == "resultRisk_page") {
        this.$store.commit("routerJump", "");
        this.$router.push({ path: "/orgRiskResult" });
        return;
      }
      if (this.routeStr == "verify_page") {
        if (!this.IOS.ios()) {
          let data = {
            notRefresh: "1",
          };
          window.android.authBack(JSON.stringify(data));
          return;
        }
        this.isTurnPage();
        return;
      }
      return;
    },
    isTurnPage() {
      if(this.shoppingCartReturn()) return
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.authBack.postMessage("");
      } else {
        window.android.authBack();
      }
    },
    turnCenter() {
      if(this.shoppingCartReturn()) return
      if (this.IOS.ios()) {
        window.webkit.messageHandlers.pushToPersonalCenter.postMessage("");
      } else {
        window.android.authBack();
      }
    },
    returnNativeFun() {
      if(this.shoppingCartReturn()) return
      let _this = this;
      // 个人&机构使用authBack返回首页
      if (this.$route.path === "/myTaxInformation" || this.$route.path === "/institutionTaxInformation") { 
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.authBack.postMessage("");
        } else {
          window.android.authBack();
        }
        return;
      }
      if (this.$route.path === "/orgRisk") {
        _this.$dialog
          .confirm({
            message: "您尚未完成风险测评，是否放弃",
            confirmButtonText: "继续测评",
            cancelButtonText: "放弃测评",
          })
          .then(() => { })
          .catch(() => {
            this.riskReturnFun();
            return;
          });
        return;
      }
      if(this.IOS.ios() && this.$route.path == "/riskReason" && this.getOpenAccount.fromOrigin && this.getOpenAccount.fromOrigin == '1'){
        window.webkit.messageHandlers.authBack.postMessage("");
        return
      }
      this.riskReturnFun();
      if (this.$route.path === "/riskAssessment1") {
        _this.$dialog
          .confirm({
            message: "您尚未完成风险测评，是否放弃",
            confirmButtonText: "继续测评",
            cancelButtonText: "放弃测评",
          })
          .then(() => { })
          .catch(() => {
            _this.$store.commit("changeRiskTitle", []);
            if (this.routeStr == "account_to_risk") {
              this.$store.commit("routerJump", "");
              this.$router.push({ path: "/accountInfo" });
            } else if (this.repeatRisk === "1") {
              this.$router.push({ path: "/riskResult1" });
              return;
            } else {
              if (this.IOS.ios()) {
                _this.turnPage_primaryDetail();
              } else {
                window.android.closePrivateFundDetailsPage();
              }
            }
          });
      } else if (
        this.$route.path === "/riskResult1" &&
        this.$router.history._startLocation != "/accountInfo"
      ) {
        if (this.routeStr == "private_page" || this.routeStr == "public_page") {
          this.$store.commit("routerJump", "");
          //风测结果页面 --> 回公募/私募详情
          if (this.IOS.ios()) {
            window.webkit.messageHandlers.riskResultToProductDetailByPermision.postMessage(
              ""
            );
          } else {
            window.android.riskResultToProductDetailByPermision();
          }
        } else {
          //风测结果页面 --> 回上页
          if (this.IOS.ios()) {
            window.webkit.messageHandlers.authBack.postMessage("");
          } else {
            window.android.authBack();
          }
        }
      } else {
        this.riskReturnFun();
        let meetConditions = MY_PATH.includes(this.$route.path);
        //路由跳转 页面commit一个str 此处匹配commit的字符串 走对应方法
        switch (this.routeStr) {
          case "kh_realInfo":
            //开户-回原生手机号
            this.turnRooter();
            break;
          default:
            break;
        }
        if (
          !this.routeStr &&
          this.$route.path === "/personalProcess/personalInfoChild"
        ) {
          bus.$emit('personalInfoChildBack')
          //权限校验开户返回上一家，需重新刷新webview
          if (
            this.getOpenAccount &&
            this.getOpenAccount.permissionOpenAccountBack
          ) {
            if (this.IOS.ios()) {
              window.webkit.messageHandlers.openAccountBackByPermission.postMessage(
                ""
              );
            } else {
              window.android.openAccountBackByPermission("");
            }
          } else {
            if (this.getOpenAccount && this.getOpenAccount.fromFixed) {
              if (this.IOS.ios()) {
                window.webkit.messageHandlers.authBack.postMessage("");
              } else {
                window.android.authBack("");
              }
            } else {
              //公募详情 -- 去开户 -- 开户中返回 -- 公募列表
              if (this.IOS.ios()) {
                window.webkit.messageHandlers.authBack.postMessage("");
              } else {
                window.android.authBack("");
              }
            }
          }
        } else {
          if (_this.notFromNative && meetConditions) {
            if (_this.fromAccountInfo === true) {
              if (
                _this.$route.path == "/modifyEmail" ||
                _this.$route.path == "/contactAdd"
              ) {
                _this.$router.push("/contactMes");
              } else {
                _this.$router.push("/accountInfo");
              }
            } else {
              if (
                _this.accountIn === true &&
                _this.$route.path == "/assetCertificate"
              ) {
                _this.$router.push("/accountInfo");
              } else {
                _this.returnDetail(-1);
              }
            }
          } else if (_this.centerFlag === "1") {
            _this.turnRooter();
          } else {
            _this.turnPage();
          }
        }
      }
    },

    skipFunction() {
      //跳过 按钮
      let currentM = this.$route.meta.skipStep.stepName;
      if (currentM === "bindCard") {
        this.$router.push("/personalProcess/investorIdentification");
      }
      if (currentM === "identityFile") {
        let list = [2, ...this.skipList];
        list = [...new Set(list)];
        this.$store.commit("changeSkipList", list);
        this.$router.push("/personalProcess/notBankCard");
        return;
      }
      if (currentM === "notBankCard") {
        let list = [3, ...this.skipList];
        list = [...new Set(list)];
        this.$store.commit("changeSkipList", list);
        this.$router.push("/personalProcess/riskTest");
        return;
      }
      if (currentM === "riskTest") {
        if (this.repeatRisk !== "1") {
          let list = [4, ...this.skipList];
          list = [...new Set(list)];
          this.$store.commit("changeSkipList", list);
        }
        this.$router.push("/personalProcess/typeIdentified");
        return;
      }
      if (currentM === "typeIdentified") {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.jumpSetPassword.postMessage("");
        } else {
          window.android.jumpSetPassword();
        }
        return;
      }
      if (currentM === "riskAssessment") {
        //判断是否需要跳到合格投资者还是ocr investorIdentification / ocr
        this.$post(this.$api.checkAlreadyImage, {
          companyId:
            this.getOpenAccount.companyId ||
            this.personInfoId.company ||
            this.companyId ||
            this.personalAccount.company ||
            this.personalAccount.companyId,
          groupCommonId: this.getOpenAccount.commonId, //必传
        }).then((res2) => {
          if (res2.code == 10000) {
            if (!res2.data) {
              //====新  开户身份证：idCardNum 此处：  certificateNo
              const data = {
                OriginRoute: "riskResult", //当前路由标志
                resultList: {}, //页面需要
                openAccountOrcenter: "1", //1是来自开户  2是来自个人中心
                company:
                  this.getOpenAccount.companyId ||
                  this.personInfoId.company ||
                  this.companyId ||
                  this.personalAccount.company ||
                  this.personalAccount.companyId || //原生需要
                  this.getOpenAccount.accountCompany,

                customName: this.customName || this.getOpenAccount.customName, //页面需要
                accountCompany:
                  this.accountCompany || this.getOpenAccount.accountCompany, //页面需要
                accountSource:
                  this.accountSource ||
                  this.accountCompany ||
                  this.getOpenAccount.accountSource, //页面需要
                // pageInfo: this.pageInfo, //页面需要
                // thirdProvinceInfo: this.thirdProvinceInfo, //页面需要
                isRiskFlag: this.isRiskFlag || this.getOpenAccount.isRiskFlag, //用户是否风测

                companyAccountId:
                  this.personInfoId.companyAccountId ||
                  this.getOpenAccount.companyAccountId, //companyAccountId
                groupPid:
                  this.getOpenAccount.groupPid || this.formInfoObj.groupPid, //groupPid
                code: this.getOpenAccount.code || this.formInfoObj.code, //code
                commonId:
                  this.getOpenAccount.commonId || this.formInfoObj.commonId, //commonId/groupCommonId
                certificateNo:
                  this.getOpenAccount.idCardNum ||
                  this.getOpenAccount.certificateNo ||
                  this.formInfoObj.certificateNo, //身份证 //此处待修改  原生不统一
                name: this.getOpenAccount.name || this.formInfoObj.name, //用户名
                OcrJump: {
                  skipRouter: "/personalProcess/investorIdentification", //被跳过 =>合格投资者认定
                  finishRouter: "/personalProcess/bindCard", //完成认证 =>银行卡
                },
                // finishRouter: "/personalProcess/bindCard"
              };
              if (this.IOS.ios()) {
                window.webkit.messageHandlers.tapToRealName.postMessage({
                  ...data,
                });
              } else {
                window.android.tapToRealName(JSON.stringify({ ...data }));
              }
            } else {
              this.$router.push({
                path: "/personalProcess/bindCard", //正常跳银行卡
              });
            }
          }
        });
      }
      if (currentM === "investorIdentification") {
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.jumpSetPassword.postMessage(
            this.submitPhoneNum
          );
        } else {
          window.android.jumpSetPassword(this.submitPhoneNum);
        }
      }

      if (currentM === "uploadMaterial") {
        //跳转输入密码
        if (this.IOS.ios()) {
          window.webkit.messageHandlers.jumpSetPassword.postMessage("");
        } else {
          window.android.jumpSetPassword();
        }
      }
    },
    goQuestion() {
      this.$router.push({
        path: "/bankCommonProblem",
        query: {},
      });
    },
    formatteEntip(val) {
      return val.replace(
        /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
        ""
      );
    },
    cancelFun() {
      this.showSureEmail = false;
      this.customEmial = this.parentIdInfo.email;
      this.dynamicTips = "";
    },
    //发送邮箱
    sendEmailFun() {
      if (!this.customEmial) {
        this.dynamicTips = "请输入邮箱号码";
        return;
      }
      let emialTrim = this.customEmial.replace(/\s*/g, "");
      let emailObj = {
        type: "email",
        testCont: emialTrim,
      };
      if (!commonRegular.openAccountReg(emailObj)) {
        this.dynamicTips = "邮箱号码格式错误，请重新输入";
        return;
      }
      let param = {
        orgCommonId: this.personalAccount.orgCommonId,
        productId: this.parentIdInfo.parentId || this.personalAccount.productId || this.aboutDocObj.productId,
        coreOssIdList: this.parentIdInfo.coreOssIdList,
        email: emialTrim,
        sysContractNo: this.parentIdInfo.sysContractNo || this.aboutDocObj.sysContractNo
      };
      this.showSureEmail = false;

      this.$post(this.$api.sendFilesToCustomerEmail, param).then((res) => {
        this.customEmial = this.parentIdInfo.email;
        this.dynamicTips = "";
        let re = res.data || {};
        this.$dialog.alert({
          message: re.info,
        });
      });
    },
    //电话
    handlePhone(phoneNum) {
      this.$dialog
        .confirm({
          title: "服务热线",
          message: phoneNum,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        })
        .then(() => {
          if (this.IOS.ios()) {
            window.location.href = "tel://" + phoneNum;
          } else {
            window.android.returnBackPhoneNumber(phoneNum);
          }
        });
    },
  },
  mounted() {
    let self = this;
    window["skipFunction"] = function () {
      self.skipFunction();
    };
    let routeArray = [...this.routePathList, ...NATIVE_BACK];
    this.$store.commit("changePathList", routeArray);
    let _this = this;
    bus.$on("getHeaderStatus", (data) => {
      _this.fixedModule = data;
    });
    bus.$on("getSearchDetail", (data) => {
      if(data){
        _this.hideDetail = false;
      }else {
        _this.hideDetail = true; //显示详情
      }
    });
    bus.$on("getSendStatus", (data) => {
      _this.fileList = data;
    });
    bus.$on("getCustomTitle", (data) => {
      this.customFundName = data;
    });
    bus.$on("aboutDocObj", (data) => {
      this.aboutDocObj = data
    });
    bus.$on("getInvestRe", (data) => {
      if (data) {
        this.getInvestList()  
      }
    });
    this.title = this.$route.name;
    setTimeout(() => {
      _this.showReturnIcon = _this.returnBtn;
      _this.urlReturn =
        _this.getOpenAccount.urlStr || _this.personalAccount.urlStr;
    }, 600);
  },
  beforeDestroy() {
    bus.$off("getHeaderStatus");
    bus.$off("getSearchDetail");
    bus.$off("getCustomTitle");
    bus.$off("aboutDocObj");
    bus.$off("getInvestRe");
  },
};
</script>

<style scoped lang="scss">
.commonTip {
  color: #333;

  .title {
    font-size: 0.15rem;
    padding: 0.24rem 0 0.06rem;
    text-align: center;
  }

  .customInput {
    /deep/.van-field__control {
      border: 1px solid #ccc;
      height: 0.38rem;
      border-radius: 0.04rem;
      text-indent: 12px;
    }
  }

  .errorTip {
    padding: 4px 16px 0;
    text-align: center;
    color: #e12817;
    font-size: 14px;
  }

  /deep/.van-cell {
    &::after {
      border: none;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    position: relative;
    border-top: 1px solid #e5e5e5;
    margin-top: 14px;

    .commonS {
      width: 50%;
      text-align: center;
      font-size: 18px;
      padding: 0.12rem 0;
    }

    .cancelBtn {
      color: #999999;
    }

    .confirmBtn {
      color: #e12817;
    }

    &::after {
      position: absolute;
      top: 0;
      left: 50%;
      content: "";
      border-left: 1px solid #e5e5e5;
      height: 100%;
    }
  }

  .stopListContent {
    font-size: 0.15rem;
    padding: 0.08rem 0.16rem 0.24rem;
    text-align: left;

    .diffStyle {
      color: #d7ae74;
    }
  }

  /deep/.van-hairline--top::after {
    border-color: #e5e5e5;
  }
}

.wrapperMod {
  top: 55%;
  transform: translate(-50%, -50%);
}

.wrapper1 {
  padding: 0.24rem 0.24rem 0.12rem;

  .top,
  .center,
  .bottom {
    text-align: left;
    font-size: 0.14rem;
    width: 100%;
    word-wrap: break-word;
    display: inline-block;
  }

  .center,
  .bottom {
    margin-top: 0.16rem;
  }
}

.header .fixedHead {
  width: 100%;
  position: fixed;
  // position: absolute;
  top: 0;
  z-index: 9999999;
}

.activeClass {
  background-image: url(../assets/images/header/floorBg.png) !important;
  background-repeat: no-repeat !important;
  background-size: 100% 1.06rem !important;
  background-color: #ca2415 !important;

  div {
    color: #fff !important;
  }

  .systemItem {
    border: none !important;
  }
}

.addPadding {
  padding-bottom: 0.6rem;
  background-size: 100% 1.3rem !important;
}

.system {
  width: 100%;
  background: #fff;
  margin: 0 auto;
  position: relative;

  .publicfunds-detail-box {
    width: 50%;
    position: relative;

    .share-news {
      position: absolute;
      top: 0;
      right: -50%;
      width: 0.2rem;
      height: 0.2rem;

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .systemItem {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.16rem;
    height: 0.48rem;
    position: relative;
    border-bottom: 0.01rem solid #eee;
    position: relative;
    .stock-code {
      display: block;
      font-size: 0.12rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }

    .leftImg {
      width: 0.22rem;
      height: 0.22rem;
      position: absolute;
      left: 0.16rem;
    }

    div {
      font-size: 0.18rem;
      color: #333;
    }

    .rightImg {
      width: 0.22rem;
      height: 0.22rem;
      position: absolute;
      right: 0.16rem;
    }

    .defaultS {
      margin-left: 0.3rem;
      margin-right: 0.3rem;
      -webkit-line-clamp: 1;
    }
  }

  .screenIng {
    position: absolute;
    right: 0.16rem;
    bottom: 0;
    line-height: 0.48rem;

    .wordDes {
      font-size: 0.16rem;
      color: #666666;
    }

    .screenIcon {
      margin-left: 0.05rem;
      font-size: 0.1rem;
      color: #999999;
    }
  }

  .rightOpera {
    position: absolute;
    right: 0.16rem;
    bottom: 0;
    height: 0.48rem;

    // overflow: hidden;
    .phoneIcon {
      width: 0.2rem;
      height: 0.2rem;
      background: url("../assets/images/account/phoneIcon.png") no-repeat;
      background-size: 100% 100%;
    }

    .skipStep {
      font-size: 0.15rem;
      color: #999;
      display: flex;
      align-items: center;
      height: 100%;

      .screenIcon {
        margin-left: 0.03rem;
        font-size: 0.15rem;
        color: #999999;
        position: relative;
        top: 0.01rem;
      }

      .quesMore {
        font-size: 0.2rem;
      }

      .distanceStyle {
        margin-left: 0.16rem;
      }
    }

    .screenIng {
      position: absolute;
      right: 0.16rem;
      bottom: 0;
      line-height: 0.48rem;

      .wordDes {
        font-size: 0.16rem;
        color: #666666;
      }

      .screenIcon {
        margin-left: 0.05rem;
        font-size: 0.1rem;
        color: #999999;
      }
    }

    .question,
    .callPhone {
      font-size: 0.16rem;
      color: #666666;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.3rem;
      height: 0.3rem;

      .questionIcon {
        width: 0.16rem;
        height: 0.16rem;

        img {
          width: 0.16rem;
          height: 0.16rem;
        }
      }
    }

    .distanceStyle {
      margin-left: 0.16rem;
    }

    .question {
      margin-top: 0.05rem;
    }

    .callPhone {
      margin-top: 0.13rem;
    }

    .searchDetail {
      color: #1677ff;
    }

    .sendStyle {
      font-size: 0.16rem;
      color: #1677ff;
      line-height: 0.48rem;
    }

    .alignClass {
      display: flex;
      align-items: center;
      height: 100%;
    }
  }

  .phone {
    line-height: 0.4rem;
  }

  .commonRight {
    position: absolute;
    right: 0.16rem;
    bottom: 0;
    height: 0.48rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .iconItem {
      font-size: 0;

      /deep/.van-icon {
        font-size: 0.2rem;
      }
    }
  }
}

.costomPopover {
  .tradingTime {
    &__top {
      display: flex;
      align-items: baseline;
      padding: 0.1rem 0.08rem 0.2rem 0.16rem;

      .tradingTitle {
        font-size: 0.16rem;
        color: #666666;
        word-break: keep-all;
        margin-right: 0.02rem;
      }

      .tradingList {
        font-size: 0.13rem;
        color: #666666;
        display: flex;
        flex-wrap: wrap;

        .tradingItem {
          margin: 0.16rem 0.08rem 0;
          width: 0.78rem;
          height: 0.24rem;
          line-height: 0.24rem;
          background-color: #f5f5f5;
          border-radius: 0.04rem;
        }

        .isClicked {
          background-color: #ffeeec;
          color: #e12817;
        }
      }
    }
  }

  .operaBtn {
    margin-top: 0.22rem;
    display: flex;
    align-items: center;

    .btnNormal {
      width: 50%;
      text-align: center;
      line-height: 0.49rem;
      font-size: 0.17rem;
      box-sizing: border-box;
    }

    .defaultBtn {
      background-color: #fff;
      color: #e12817;
      border-top: 1px solid #eeeeee;
    }

    .primaryBtn {
      background-color: #e12817;
      color: #fff;
      border-top: 1px solid #e12817;
    }
  }
}

.share-news-scroll {
  position: absolute;
  top: 50%;
  transform: translateY(50%);
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  right: 0.16rem;

  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.share-news-scroll-primary {
  position: absolute;
  bottom: 0.13rem;
  width: 0.2rem;
  height: 0.2rem;
  float: right;
  right: 0.16rem;

  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
